import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseQuery";

// Team member interface
export interface TeamMember {
  id: number;
  name: string;
  email: string;
  is_active: boolean;
  date_joined: string;
}

// Organization interface
export interface Organization {
  id: number;
  name: string;
}

// Team interface based on the provided API response
export interface Team {
  id: number;
  name: string;
  description: string;
  organization: Organization;
  created_by: TeamMember;
  updated_by: TeamMember;
  created_date: string;
  modified_date: string;
  member_count: number;
  members: TeamMember[];
}

// Teams API response interface
export interface TeamsApiResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Team[];
}

export const teamsApi = createApi({
  baseQuery,
  reducerPath: "teamsApi",
  tagTypes: ["Teams"],
  endpoints: (build) => ({
    getTeamsByOrganization: build.query<Team[], number>({
      query: (organizationId) => `organizations/${organizationId}/teams/`,
      providesTags: ["Teams"],
      transformResponse: (response: TeamsApiResponse) => response.results,
    }),
  }),
});

export const { useGetTeamsByOrganizationQuery } = teamsApi;
